import * as SelectPrimitive from "@radix-ui/react-select";
import React from "react";
import { SudoButton } from "../SudoButton";

export type SelectVariant = "primary" | "secondary" | "tertiary" | "secondaryGrey" | "tertiaryGrey";
export type IconStatus = "default" | "success" | "danger";
export type OptionAlignment = "left" | "center";

export interface SharedBaseOption {
  value: string;
  label: string;
  indentLevel?: number;
  subLabel?: string;
  icon?: {
    label?: string;
    src: string;
    status?: IconStatus;
  };
  async?: {
    state: string;
    loadingPercentage: number;
    variant?: SelectVariant;
  };
}

export const renderSelectBody = (option: SharedBaseOption, selectedValue: string | undefined, selectedStateStyles: (option: any) => string, optionAlignment: OptionAlignment): JSX.Element => {
  const leftPadding = 12 + (option.indentLevel ?? 0) * 12;

  if (option.async) {
    return (
      <SelectPrimitive.Item
        key={`${option.value}-async`}
        value={option.value}
        className="rounded-[10px] outline-offset-[-2px] px-0 mt-0 mb-1 last:mb-0 group my-1"
        aria-selected={option.value === selectedValue}
      >
        <SelectPrimitive.Value asChild={true}>
          <SudoButton
            variant={option.async.variant || "tertiaryGrey"}
            state={option.async.state as "loading"}
            loadingPercentage={option.async.loadingPercentage}
            className={`w-full [&&]:justify-start pr-4 ${option.async.state === "loading" ? "[&&]:pl-2 hover:before:ml-[-7px]" : "px-0"}`}
            iconSize={24}
            leftIcon={option.icon?.src}
          >
            <SelectPrimitive.ItemText>
              <div
                className="text-left"
                style={{ paddingLeft: option.icon ? undefined : leftPadding }}
              >
                <p>{option.label}</p>
                {option.subLabel && <p className="text-xs">{option.subLabel}</p>}
              </div>
            </SelectPrimitive.ItemText>
          </SudoButton>
        </SelectPrimitive.Value>
      </SelectPrimitive.Item>
    );
  }

  return (
    <SelectPrimitive.Item
      key={`${option.value}-regular`}
      value={option.value}
      className="outline-none px-0 mt-0 mb-1 last:mb-0 group my-1"
      aria-selected={option.value === selectedValue}
    >
      <SudoButton
        variant="tertiaryGrey"
        className={`w-full first:mt-0 ${selectedStateStyles(option)} last:mb-0 px-2 ${
          option.icon ? (optionAlignment === "left" ? "pl-2 group-hover:before:ml-[-7px] group-focus:before:ml-[-7px] group-active:before:ml-[-5px]" : "pl-2 group-hover:before:ml-[7px]") : "pl-0"
        } ${optionAlignment === "left" ? "justify-start" : "justify-center"}`}
        iconSize={24}
        leftIcon={option.icon?.src}
      >
        <SelectPrimitive.ItemText>
          <div
            className="text-left"
            style={{ paddingLeft: option.icon ? undefined : leftPadding }}
          >
            <p>{option.label}</p>
            {option.subLabel && <p className="text-xs">{option.subLabel}</p>}
          </div>
        </SelectPrimitive.ItemText>
      </SudoButton>
    </SelectPrimitive.Item>
  );
};
